<aside class="sidebar-sec" [ngClass]="{ collapsed: isCollapsed }">
  <div class="sidelogoss">
    <img *ngIf="!isCollapsed" [src]="bucketurl + '/images/suzuki_logo.png'" style="width: 60%; margin-left: 35px" alt />
    <img *ngIf="isCollapsed" [src]="bucketurl + '/images/suzuki_s.png'" style="width: 30%; margin-left: 10px" alt />
    <img style="width: 20px; margin-right: 10px; cursor: pointer" [src]="bucketurl + '/menu/menu_unfold.png'" alt
      (click)="toggleSidebar()" />
  </div>
  <hr style="opacity: 0.25 !important; border-top: 1px #8f8f8f solid" />
  <div class="sidebar-scroll">
    <ul class="sidebar-menu">
      <ng-container *ngIf="roleService.hasRole(role_id, ROLE_GROUP_CONSTANTS.SIDEBAR_MENU)">
        <!-- <li class="main-menu has-collapsible">
                    <a class="crts" routerLink="/suzuki/products" id="products" routerLinkActive="active" title="Products"
                        (click)="setActive('products')"><span><img style="margin-left: 5px;"
                                [src]="bucketurl + '/menu/' + (selectedTarget == 'products' ? 'all_lead_selected' : 'leads') + '.png'"
                                alt class="menu-img"></span><span class="side-font">Products</span></a>
                </li> -->
        <!-- <li class="main-menu has-collapsible">
                    <a class="crts" routerLink="/suzuki/users" id="users" routerLinkActive="active" title="Users"  #linkRef="routerLinkActive"
                        (click)="setActive('users')"><span><img style="margin-left: 5px;"
                                [src]="bucketurl + '/menu/' + (linkRef.isActive ? 'all_lead_selected' : 'leads') + '.png'"
                                alt class="menu-img"></span><span class="side-font">Users</span></a>
                </li>
                <li class="main-menu has-collapsible">
                    <a class="crts" routerLink="/suzuki/document-upload" id="document-upload" routerLinkActive="active" #linkRef1="routerLinkActive"
                        title="Document Upload" (click)="setActive('document-upload')"><span><img
                                style="margin-left: 5px;"
                                [src]="bucketurl + '/menu/' + (linkRef1.isActive ? 'all_lead_selected' : 'leads') + '.png'"
                                alt class="menu-img"></span><span class="side-font">Document Upload</span></a>
                </li> -->
        <ng-container>
          <!-- <li class="main-menu has-collapsible">
            <a class="crts" routerLink="/suzuki/enquiries-dashboard" id="enquiries" routerLinkActive="active"
              #linkRef4="routerLinkActive" title="Enquiries" (click)="setActive('enquiries')"><span><img
                  style="margin-left: 5px;"
                  [src]="bucketurl + '/menu/' + (linkRef4.isActive ? 'enquiry-selected' : 'enquiry') + '.png'" alt
                  class="menu-img"></span><span class="side-font">Enquiries</span></a>
          </li> -->
          <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/enquiries-dashboard-new" id="enquiries_beta"
                            routerLinkActive="active" #linkRef4="routerLinkActive" title="Enquiries"
                            (click)="setActive('enquiries_beta')"><span><img style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRef4.isActive ? 'enquiry-selected' : 'enquiry') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Enquiries</span></a>
                    </li> -->
          <!-- <li class="main-menu has-collapsible">
            <a class="crts" routerLink="/suzuki/test-ride-dashboard" id="testride" routerLinkActive="active"
              #linkRef5="routerLinkActive" title="Test Ride" (click)="setActive('testride')"><span><img
                  style="margin-left: 5px;"
                  [src]="bucketurl + '/menu/' + (linkRef5.isActive ? 'all_lead_selected' : 'leads') + '.png'" alt
                  class="menu-img"></span><span class="side-font">Test Ride</span></a>
          </li> -->
          <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/test-ride-dashboard-new" id="testride_beta" routerLinkActive="active"
                            #linkRef5="routerLinkActive" title="Test Ride Beta" (click)="setActive('testride_beta')"><span><img
                                    style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRef5.isActive ? 'all_lead_selected' : 'leads') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Test Ride</span></a>
                    </li> -->

          <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/followup-dashboard" id="followup" routerLinkActive="active"
                            #linkRef6="routerLinkActive" title="Follow Up" (click)="setActive('followup')"><span><img
                                    style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRef6.isActive ? 'enquiry-selected' : 'follow-up') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Follow Up</span></a>
                    </li>  -->

          <!-- <li class="main-menu has-collapsible">
            <a class="crts" routerLink="/suzuki/followup-dashboard-new" id="followup_beta" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" [class.active]="activeUrl === '/suzuki/followup-dashboard-new'"
              (click)="onMenuClick('/suzuki/followup-dashboard-new')" #linkRef6="routerLinkActive" title="Follow Up"><span><img
                  style="margin-left: 5px;"
                  [src]="bucketurl + '/menu/' + (linkRef6.isActive ? 'enquiry-selected' : 'follow-up') + '.png'" alt
                  class="menu-img"></span><span class="side-font">Follow Up</span></a>
          </li>-->

          <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/productivity-dashboard" id="productivity"
                            routerLinkActive="active" #linkRef7="routerLinkActive" title="Productivity"
                            (click)="setActive('productivity')"><span><img style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRef7.isActive ? 'enquiry-selected' : 'enquiry') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Productivity</span></a>
                    </li>  -->

          <!--  <li class="main-menu has-collapsible">
            <a class="crts" routerLink="/suzuki/productivity-dashboard-new" id="productivity_beta"
              [routerLinkActiveOptions]="{ exact: true }"
              [class.active]="activeUrl === '/suzuki/productivity-dashboard-new'"
              (click)="onMenuClick('/suzuki/productivity-dashboard-new')" routerLinkActive="active"
              #linkRef7="routerLinkActive" title="Productivity"><span><img style="margin-left: 5px;"
                  [src]="bucketurl + '/menu/' + (linkRef7.isActive ? 'enquiry-selected' : 'enquiry') + '.png'" alt
                  class="menu-img"></span><span class="side-font">Productivity</span></a>
          </li> -->


          <!-- <li class="main-menu has-collapsible">
            <a class="crts" routerLink="/suzuki/lost-dashboard" id="lost" routerLinkActive="active"
              #linkRef8="routerLinkActive" title="Lost" (click)="setActive('lost')"><span><img style="margin-left: 5px;"
                  [src]="bucketurl + '/menu/' + (linkRef8.isActive ? 'lost_selected' : 'lost') + '.png'" alt
                  class="menu-img"></span><span class="side-font">Lost</span></a>
          </li> -->
          <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/lost-dashboard-new" id="lost_beta" routerLinkActive="active"
                           [routerLinkActiveOptions]="{ exact: true }" 
                           [class.active]="activeUrl === '/suzuki/lost-dashboard-new'"
                           (click)="onMenuClick('/suzuki/lost-dashboard-new')"
                           #linkRef8="routerLinkActive" title="Lost" ><span><img
                                    style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRef8.isActive ? 'lost_selected' : 'lost') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Lost</span></a>
                    </li>-->
          <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/digital-desk" id="digitalDesk" routerLinkActive="active"
                            #linkRefDD="routerLinkActive" title="Digital Desk" (click)="setActive('digitalDesk')"><span><img
                                    style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRefDD.isActive ? 'enquiry-selected' : 'enquiry') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Digital Desk</span></a>
                    </li> -->
          <!-- <li class="main-menu has-collapsible">
            <a class="crts" routerLink="/suzuki/digital-desk-dashboard-new" id="digitalDesk" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" [class.active]="activeUrl === '/suzuki/digital-desk-dashboard-new'"
              (click)="onMenuClick('/suzuki/digital-desk-dashboard-new')" #linkRefDD="routerLinkActive"
              title="Digital Desk"><span><img style="margin-left: 5px;"
                  [src]="bucketurl + '/menu/' + (linkRefDD.isActive ? 'enquiry-selected' : 'enquiry') + '.png'" alt
                  class="menu-img"></span><span class="side-font">Digital Desk</span></a>
          </li> -->
          <ng-container *ngIf="roleService.hasRole(role_id,ROLE_GROUP_CONSTANTS.SIDEBAR_REPORTS)">
            <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/reports" id="reports" routerLinkActive="active"
                           [routerLinkActiveOptions]="{ exact: true }" 
                           [class.active]="activeUrl === '/suzuki/reports'"
                           (click)="onMenuClick('/suzuki/reports')"
                           #linkRef9="routerLinkActive" title="Reports"><span><img
                                    style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRef9.isActive ? 'create_lead_selected' : 'create_lead') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Reports</span></a>
                    </li> -->
            <!-- <li class="main-menu has-collapsible">
              <a class="crts" routerLink="/suzuki/reports-new" id="reports" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }" [class.active]="activeUrl === '/suzuki/reports-new'"
                (click)="onMenuClick('/suzuki/reports-new')" #linkRef9="routerLinkActive" title="Reports"><span><img
                    style="margin-left: 5px;"
                    [src]="bucketurl + '/menu/' + (linkRef9.isActive ? 'create_lead_selected' : 'create_lead') + '.png'"
                    alt class="menu-img"></span><span class="side-font">Reports</span></a>
            </li> -->
            <!-- <li class="main-menu has-collapsible">
                        <a class="crts" routerLink="/suzuki/bi-chart" id="bi-charts" routerLinkActive="active"
                            #linkRef10="routerLinkActive" title="Bi Charts" (click)="setActive('bi-charts')"><span><img
                                    style="margin-left: 5px;"
                                    [src]="bucketurl + '/menu/' + (linkRef10.isActive ? 'enquiry-selected' : 'enquiry') + '.png'"
                                    alt class="menu-img"></span><span class="side-font">Bi Charts</span></a>
                    </li> -->
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="role_id === ROLE_CONSTANTS.OM">
        <li class="main-menu has-collapsible">
          <a class="crts" routerLink="/suzuki/escalation-matrix" id="escalation-matrix" routerLinkActive="active"
            title="Escalation Matrix" #linkRef2="routerLinkActive" (click)="setActive('escalation-matrix')"><span><img
                style="margin-left: 5px" [src]="
                  bucketurl +
                  '/menu/' +
                  (linkRef2.isActive ? 'all_lead_selected' : 'leads') +
                  '.png'
                " alt class="menu-img" /></span><span class="side-font">Escalation Matrix</span></a>
        </li>
        <li class="main-menu has-collapsible">
          <a class="crts" routerLink="/suzuki/users" id="users" routerLinkActive="active" title="Users"
            #linkRef3="routerLinkActive" (click)="setActive('users')"><span><img style="margin-left: 5px" [src]="
                  bucketurl +
                  '/menu/' +
                  (linkRef3.isActive ? 'all_lead_selected' : 'leads') +
                  '.png'
                " alt class="menu-img" /></span><span class="side-font">Users</span></a>
        </li>
      </ng-container>
      <li class="main-menu has-collapsible guide" style="position: absolute; bottom: 0">
        <a class="crts" routerLink="/suzuki/help-and-support" id="users-guide" routerLinkActive="active"
          #linkRefUser="routerLinkActive" title="User Guide" (click)="setActive('users-guide')"><span><img [src]="
                bucketurl +
                '/menu/' +
                (linkRefUser.isActive ? 'lost_selected' : 'lost') +
                '.png'
              " alt="" class="menu-img" /></span><span class="side-font">Help and Support</span></a>
      </li>
<li class="main-menu has-collapsible"  *ngIf="(role_id === 2 || role_id === 6 || role_id === 7 || role_id === 8 || role_id === 10)">
        <a
          class="crts"
          href="javascript:void(0)"
          (click)="toggleSubMenu('targetSetting')"
        >
          <span
            ><img
              style="margin-left: 5px"
              [src]="
                bucketurl +
                '/menu/' +
                (selectedTarget == 'targetSetting' ? 'target' : 'enquiry') +
                '.png'
              " alt class="menu-img" /></span>
          <span class="side-font">Dealer Visit Report</span>
          <i class="arrow" [ngClass]="{ rotate: openSubMenu === 'targetSetting' }"></i>
        </a>

         <ul *ngIf="openSubMenu === 'targetSetting'" class="submenu">
          <li>
            <a class="crts" routerLink="/suzuki/dealer-visit-report/target-setting" routerLinkActive="active"
              (click)="setActive('target-setting-target')">
              <span>
                <img style="margin-left: 5px" [src]="
                    bucketurl +
                    '/menu/' +
                    (selectedTarget == 'targetSetting'
                      ? 'enquiry_selected'
                      : 'enquiry') +
                    '.png'
                  " alt class="menu-img" />
              </span>
              <span class="side-font">Target Setting</span>
            </a>
          </li>
          <li>
            <a class="crts" routerLink="/suzuki/dealer-visit-report/report" routerLinkActive="active"
              (click)="setActive('target-setting-report')">
              <span>
                <img style="margin-left: 5px" [src]="
                    bucketurl +
                    '/menu/' +
                    (selectedTarget == 'targetSetting' ? 'report' : 'enquiry') +
                    '.png'
                  " alt class="menu-img" />
              </span>
              <span class="side-font">Variance & Retail Conversion Report</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="main-menu has-collapsible" *ngIf="(role_id === 2 || role_id === 6 || role_id === 7 || role_id === 8 || role_id === 10)">
        <a class="crts" routerLink="/suzuki/dealer-insight-report" id="dealerInsight" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }" [class.active]="activeUrl === '/suzuki/dealer-insight-report'"
          (click)="onMenuClick('/suzuki/dealer-insight-report')" #linkRefDI="routerLinkActive"
          title="Dealer Insight Report">
            <svg style="vertical-align: middle; " width="10" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-img">
              <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A5 5 0 0 0 8 8c0 1 .3 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5M9 18h6M10 22h4"></path>
            </svg>
          <span class="side-font">Dealer Insight Report</span>
        </a>
      </li>
      <li class="main-menu has-collapsible" id="lms">
        <a class="crts" [href]="biDashboardUrl" title="BI Dashboard">
          <span class="side-font">BI Dashboard</span>
        </a>
      </li>



      <!-- <li class="main-menu has-collapsible" id="reset-password">
                <a class="crts" routerLink="/suzuki/reset-password"
                    routerLinkActive="active" title="Reset Password"
                    (click)="setActive('reset-password')"><span><img
                            style="margin-left: 5px;"
                            [src]="bucketurl + '/menu/' + (selectedTarget == 'reset-password' ? 'all_lead_selected' : 'leads') + '.png'"
                            alt
                            class="menu-img"></span><span
                        class="side-font">Reset Password</span></a>
            </li>
            <li class="main-menu has-collapsible" id="user-details">
                <a class="crts" routerLink="/suzuki/user-details"
                    routerLinkActive="active" title="User-Details"
                    (click)="setActive('user-details')"><span><img
                            style="margin-left: 5px;"
                            [src]="bucketurl + '/menu/' + (selectedTarget == 'user-details' ? 'all_lead_selected' : 'leads') + '.png'"
                            alt
                            class="menu-img"></span><span
                        class="side-font">User Details</span></a>
            </li> -->

      <!-- <li class="main-menu has-collapsible" id="lost">
                <a class="crts" routerLink="/suzuki/lost" routerLinkActive="active" title="Lost"
                    (click)="setActive('lost')"><span><img style="margin-left: 5px;"
                            src="/assets/menu/{{ selectedTarget == 'lost'  ? 'lost_selected' : 'lost' }}.png" alt=""
                            class="menu-img"></span><span class="side-font">Lost</span></a>
            </li>
            <li class="main-menu has-collapsible" id="assigned">
                <a class="crts" routerLink="/suzuki/assigned" routerLinkActive="active" title="Assigned"
                    (click)="setActive('assigned')"><span><img style="margin-left: 5px;"
                            src="/assets/menu/{{ selectedTarget == 'assigned'  ? 'assigned_selected' : 'assigned' }}.png"
                            alt="" class="menu-img"></span><span class="side-font">Assigned</span></a>
            </li>
            <li class="main-menu has-collapsible" id="create-lead">
                <a class="crts" routerLink="/suzuki/create-lead" routerLinkActive="active" title="Create Lead"
                    (click)="setActive('create-lead')"><span><img style="margin-left: 5px;"
                            src="/assets/menu/{{ selectedTarget == 'create-lead'  ? 'create_lead_selected' : 'create_lead' }}.png"
                            alt="" class="menu-img"></span><span class="side-font">Create Lead</span></a>
            </li> -->
    </ul>
  </div>
</aside>
